import { WhiteModal } from '../../components/Modal';
import StatusTable from '../../components/StatusTable';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface StatusDefinitionsModalProps {
  open: boolean;
  onClose: () => void;
  data: readonly string[];
  title: string;
  statusTag?: (status: string) => React.ReactNode;
  statusDefinitions?: string;
  statusTitle: string;
}

export default function StatusDefinitionsModal({
  open,
  onClose,
  data,
  title,
  statusTag,
  statusDefinitions,
  statusTitle,
}: StatusDefinitionsModalProps) {
  const { t } = useTranslation();

  return (
    <WhiteModal
      open={open}
      onCancel={onClose}
      title={t(title)}
      closable={true}
      footer={null}
    >
      <StatusTable
        data={data}
        statusTag={statusTag}
        statusDefinitions={statusDefinitions}
        statusTitle={statusTitle}
        statusColumnWidthPercent={50}
      />
    </WhiteModal>
  );
}
